import { UserComponent } from '@craftjs/core';
import { FormGeneralProps } from './BaseControlTypes';

export type FormTextProps = FormGeneralProps & {
  text: string;
  isHiddenOnOverview?: boolean;
};

export const formTextDefaultProps: FormTextProps = {
  text: '',
};

export type FormTextComponent = UserComponent<FormTextProps>;
